
import { 
  CharacterFeature
} from "@dndModels";


/**
 * This represents a feature 
 * (either via race, background, class, or subclass)
 * which the character has.  
 * The FeatureBase is what it is based on, but the 
 * difference is that here we will have values for the choices.
 */
export class SummonFeature extends CharacterFeature {
  creature_ability: any = null;
  num: number | null = null;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.creature_ability = obj.creature_ability ? obj.creature_ability : null;
      this.num = obj.num ? obj.num : null;
    }
  }

  toDBObj(): any {
    const from_super = super.toDBObj();
    return {
      ...from_super,
      creature_ability: this.creature_ability,
      num: this.num,
      summonFeature: true
    };
  }

  copy(copyMe: SummonFeature): void {
    super.copy(copyMe);
    this.creature_ability = copyMe.creature_ability;
    this.num = copyMe.num;
  }
}